
import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch, Prop } from 'vue-property-decorator';
import { db } from '@/plugins/firebase';
import { Entry, Project, Collection } from '@/types';
import MarkdownIt from 'markdown-it';
const md = new MarkdownIt();

@Component
export default class ProjectIndex extends Vue {
  @Prop(Object) project: Project;
  @Prop(Array) collections: Collection[];

  detail(): string {
    if (this.project && this.project.markdown) {
      return md.render(this.project.markdown);
    } else {
      return '';
    }
  }

  created() {
    //console.log(this.project);
  }
}
